/*
 * Title: KnightsCard.tsx
 * Author: Chris Rosa
 * Email: chris@encore.fans
 * Description: Desktop Sidebar shows on Leadboard and Reward Pages
 * Date: 30 Jun 2022
 * Copyright (c) Encore, 2022
 * Version:0.1.0
 */

import React from "react";
import global from "@assets/global.png";
import instagram_white from "@assets/instagram_white.png";
import signals from "@assets/signals.png";
import twitter from "@assets/twitter.png";
import youtube from "@assets/youtube.png";
import { Link } from "react-router-dom";
import Logo from "@components/Logo";
import { connect } from "react-redux";
import Icon from "@components/Icon";
import { makeSecureUrl, routerLink } from "@helpers/common";
import Icon_White from "@components/Icon_white";

type Props = {};
type MyState = {};
class KnightsCard extends React.Component<Props | any, MyState> {
  state: MyState = {};

  render() {
    const { user } = this.props;

    return (
      <div className="bg-[#1D1D1D] lg:rounded-[20px] rounded-b-[40px] lg:py-[50px] py-[20px]">
        <div className="text-center">
          <Logo
            logo_letter="true"
            className="lg:max-h-[120px] max-h-[60px] h-full w-[auto] object-contain mx-auto rounded-full"
          />
          <h4 className="text-[#fff] font-medium lg:text-[28px] text-[24px] lg:mt-[40px] mt-[20px]">
            {user?.name}
          </h4>
          <p className="text-[#fff]/80 font-light lg:text-[20px] text-[16px] w-[274px] mx-auto lg:mt-[10px] mt-[5px] lg:mb-[40px] mb-[15px]">
            Create a free account to start earning rewards.
          </p>
        </div>
        <a
          href={`${routerLink(user?.username)}?ref=signin`}
          className="flex items-center justify-center text-black font-medium lg:text-[18px] text-[16px] bg-tile rounded-full lg:w-[115px] w-[98px] lg:h-[42px] h-[36px] mx-auto object-contain"
        >
          enter
        </a>
        <div className="lg:mt-[40px] mt-[20px]">
          <div className="flex items-center justify-center">
            {this.props?.touchpoint?.data?.url &&
              this.props?.touchpoint?.data?.url !== "" && (
                <a
                  target={"_blank"}
                  className="text-[white]/30 mr-2 hover:text-[white]/90 bg-[#555555] h-[35px] w-[35px] rounded-full text-center font-normal flex items-center justify-center"
                  href={makeSecureUrl(this.props?.touchpoint?.data?.url || "")}
                >
                  <img
                    src={global}
                    className="object-contain w-[19px] h-[19px]"
                  />
                </a>
              )}
            {(this.props.touchpoint?.creatorstouchpoint?.touchpoints || []).map(
              (item, key) => (
                <div key={key}>
                  {item.touchpoint.touchpoint === "featured" ||
                  item.touchpoint.touchpoint === "typeform"
                    ? null
                    : item.touchpoint.url && (
                        <a
                          key={key}
                          rel="noreferrer"
                          href={item.touchpoint.url}
                          target={item.touchpoint.url ? "_blank" : ""}
                        >
                          <div className="bg-[#555555] h-[35px] w-[35px] mr-2 rounded-full flex items-center justify-center">
                            <Icon_White icon={item.touchpoint.touchpoint} />
                          </div>
                        </a>
                      )}
                </div>
              )
            )}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ user, creator }) => {
  return {
    user: creator.data,
    touchpoint: creator,
  };
};

const mergeProps = (stateProps: any, dispatchProps: any) => {
  const { dispatch } = dispatchProps;
  const { actions } = require("@redux/UserRedux");
  const { actions: acreator } = require("@redux/CreatorRedux");
  return {
    ...stateProps,
    fetch: data => {
      acreator.fetchProfileData(dispatch, data);
    },
  };
};

export default connect(mapStateToProps, undefined, mergeProps)(KnightsCard);
